/**
 * This Tab implementation is an alternative to frontends/app/src/components/RoutedTabNew.tsx
 * Some differences:
 *  - Based on Material instead of Semantic UI
 *    - Tab indicator line is animated on selection.
 *  - You must pass an "href" prop so you can right click to open in a new browser tab/window.
 *  - Forwards saved location state to work in conjunction with BackLink component.
 *    i.e. Clicking on a tab is not treated as loading a fresh page for the purposes of taking you back.
 */
import TabComp from '@material-ui/core/Tab';
import {MOON_600, MOON_950} from '@wandb/weave/common/css/globals.styles';
import React from 'react';
import {useHistory, useLocation} from 'react-router-dom';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {LocationState} from '../BackLink';

const StyledTab = styled(TabComp)`
  && {
    padding: 16px 2px;
    min-width: 0;
    margin-right: 36px;
    font-size: 16px;
    line-height: 16px;
    font-weight: 600;
    color: ${MOON_600};
    opacity: 1;
    &:hover,
    &:active {
      color: ${MOON_950};
    }
    &.Mui-selected {
      color: ${MOON_950};
    }
  }
`;

// TODO: Can this type be made more specific?
export const Tab = (props: any) => {
  const history = useHistory();
  const {state} = useLocation<LocationState>();
  const onClick = (event: React.MouseEvent) => {
    event.preventDefault();
    if (props.href === window.location.pathname) {
      return;
    }
    history.push({
      pathname: props.href,
      state,
    });
  };
  // We disable our linter because we are using history.push
  // eslint-disable-next-line wandb/no-a-tags
  return <StyledTab {...props} component="a" onClick={onClick} />;
};
